import { Tags, NewProviderListTags } from 'src/components';

const ProspectListAndTagContent = ({ provider, hideProspectList }) => {
  return (
    <div>
      <Tags tags={provider.tags} tagType="tag" />
      {!hideProspectList && (
        <NewProviderListTags lists={provider.provider_lists} />
      )}
    </div>
  );
};

export default ProspectListAndTagContent;
